<div class="identity-list-container" [testId]="'identity-list-container'">
  <div class="page-topbar" [testId]="'identity-list-header'">
    <div class="card-header">
      <div class="card-heading">
        <h3 class="page-title">{{ 'servicenumber.service-identity' | i18n }}</h3>
      </div>
      <div class="card-actions" [testId]="'identity-list-action-container'">
        <button
          nz-button
          class="refresh-button"
          (click)="loadData()"
          [nzTooltipTitle]="'common.refresh' | i18n"
          nz-tooltip
          [testId]="'identity-list-refresh-btn'"
        >
          <nz-icon nzType="reload" nzTheme="outline" [testId]="'identity-list-refresh-icon'" />
          <span [testId]="'identity-list-refresh-text'">{{ 'common.refresh' | i18n }}</span>
        </button>
        <button
          nz-button
          nzType="primary"
          class="add-button"
          [nzTooltipTitle]="'common.add' | i18n"
          nz-tooltip
          (click)="addIdentity()"
          [testId]="'identity-list-add-btn'"
        >
          <nz-icon nzType="plus" nzTheme="outline" [testId]="'identity-list-add-icon'" />
          <span [testId]="'identity-list-add-text'">{{ 'common.add' | i18n }}</span>
        </button>
      </div>
    </div>
  </div>
  <div class="content-scrollable" [testId]="'identity-list-content'">
    <div class="table-surface">
      <nz-table
        #basicTable
        class="identity-table"
        [nzScroll]="{ x: '800px', y: 'calc(100% - 10px)' }"
        [nzData]="listOfData"
        [nzFrontPagination]="false"
        [nzShowPagination]="false"
        nzSize="small"
        [nzLoading]="loading"
        [testId]="'identity-list-table'"
      >
        <thead [testId]="'identity-list-table-head'">
          <tr [testId]="'identity-list-table-head-row'">
            <th scope="col" [nzWidth]="'80px'" [testId]="'identity-list-avatar-header'">{{ 'servicenumber.identity.avatar' | i18n }}</th>
            <th scope="col" [nzWidth]="'150px'" [testId]="'identity-list-name-header'">{{ 'servicenumber.identity.name' | i18n }}</th>
            <th scope="col" [nzWidth]="'100px'" [testId]="'identity-list-type-header'">{{ 'servicenumber.identity.type' | i18n }}</th>
            <th scope="col" [nzWidth]="'100px'" [testId]="'identity-list-default-header'">{{ 'servicenumber.identity.default' | i18n }}</th>
            <th scope="col" [nzWidth]="'200px'" [testId]="'identity-list-actions-header'">{{ 'common.actions' | i18n }}</th>
          </tr>
        </thead>
        <tbody [testId]="'identity-list-table-body'">
          <tr *ngFor="let item of listOfData" [testId]="'identity-list-table-row-' + item.id">
            <td [testId]="'identity-list-avatar-cell-' + item.id">
              <nz-avatar [nzSrc]="item.avatarUrl" [nzSize]="40" [testId]="'identity-list-avatar-' + item.id" />
            </td>
            <td [testId]="'identity-list-name-cell-' + item.id">{{ item.name }}</td>
            <td class="type-cell" [testId]="'identity-list-type-cell-' + item.id">
              <nz-tag [nzColor]="getTypeColor(item.type)" [testId]="'identity-list-type-tag-' + item.id">{{
                getTypeText(item.type)
              }}</nz-tag>
            </td>
            <td class="default-cell" [testId]="'identity-list-default-cell-' + item.id">
              <nz-tag [nzColor]="item.isDefault ? 'blue' : 'default'" [testId]="'identity-list-default-tag-' + item.id">{{
                item.isDefault ? ('servicenumber.identity.is-default' | i18n) : ('servicenumber.identity.not-default' | i18n)
              }}</nz-tag>
            </td>
            <td class="actions-cell" [testId]="'identity-list-actions-cell-' + item.id">
              <button
                nz-button
                nzType="primary"
                nzSize="small"
                nzShape="circle"
                (click)="editIdentity(item.id)"
                [nzTooltipTitle]="'common.edit' | i18n"
                nz-tooltip
                [testId]="'identity-list-edit-btn-' + item.id"
              >
                <nz-icon nzType="edit" nzTheme="outline" [testId]="'identity-list-edit-icon-' + item.id" />
              </button>
              <nz-divider nzType="vertical" [testId]="'identity-list-divider1-' + item.id" />
              <button
                *ngIf="!item.isDefault"
                nz-button
                nzType="primary"
                nzSize="small"
                nzShape="circle"
                (click)="setDefaultIdentity(item.id)"
                [nzTooltipTitle]="'servicenumber.identity.set-as-default' | i18n"
                nz-tooltip
                [testId]="'identity-list-set-default-btn-' + item.id"
              >
                <nz-icon nzType="star" nzTheme="outline" [testId]="'identity-list-set-default-icon-' + item.id" />
              </button>
              <nz-divider *ngIf="!item.isDefault" nzType="vertical" [testId]="'identity-list-divider2-' + item.id" />
              <button
                nz-button
                nzType="primary"
                nzDanger
                nzSize="small"
                nzShape="circle"
                (click)="deleteIdentity(item.id)"
                [nzTooltipTitle]="'common.delete' | i18n"
                nz-tooltip
                [testId]="'identity-list-delete-btn-' + item.id"
              >
                <nz-icon nzType="delete" nzTheme="outline" [testId]="'identity-list-delete-icon-' + item.id" />
              </button>
            </td>
          </tr>
        </tbody>
      </nz-table>
    </div>
  </div>
</div>
